module.exports = __webpack_public_path__ + "assets/a477133eba1c78145ebc981e7a16ff36.png";